module.exports = __webpack_public_path__ + "media/images/calendar-569c4a75e68cdc752d9385c2c2351418.png";